import { ApiUrl } from "../utils/modules";
import { header } from "../utils/modules";

class PaiementServices {
  constructor(api) {
    this.api = api;
  }

  getAll() {
    return this.api.get(ApiUrl + "paiement", {
      ...header("json"),
    });
  }

  getOne(id) {
    return this.api.get(ApiUrl + `paiement/${id}`, {
      ...header("json"),
    });
  }

  update(id, data) {
    return this.api.patch(ApiUrl + `paiement/${id}`, data, {
      ...header("json"),
    });
  }

  paiementMvola(data) {
    return this.api.post(ApiUrl + "paiement/mvola", data, {
      ...header("json"),
    });
  }

  getMyPaiements(id) {
    return this.api.get(ApiUrl + `paiement/me/${id}`, {
      ...header("json"),
    });
  }
}

export default PaiementServices;
